/**
 * Formata um número de documento como CPF ou CNPJ.
 * @param doc String contendo os dígitos do documento.
 * @returns Documento formatado ou a string original se não for CPF/CNPJ válido.
 */
export function formatDocument(doc: string): string {
    const cleaned = (doc || '').replace(/[^\d]/g, ''); // Garante limpeza de caracteres não numéricos

    if (cleaned.length === 11) {
        // Formato CPF: 000.000.000-00
        return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (cleaned.length === 14) {
        // Formato CNPJ: 00.000.000/0000-00
        return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    // Retorna o documento limpo se não for CPF nem CNPJ
    return cleaned;
}

/**
 * Identifica o tipo de documento com base no número de dígitos
 * @param doc String contendo os dígitos do documento.
 * @returns 'CPF', 'CNPJ' ou 'Desconhecido'
 */
export function getDocumentType(doc: string): 'CPF' | 'CNPJ' | 'Desconhecido' {
    const cleaned = (doc || '').replace(/[^\d]/g, '');

    if (cleaned.length === 11) {
        return 'CPF';
    } else if (cleaned.length === 14) {
        return 'CNPJ';
    }

    return 'Desconhecido';
}

/**
 * Extrai o documento de uma entidade baseado no legal_personality
 * @param entity Entidade com possíveis propriedades de documento
 * @returns String com o documento extraído, ou string vazia se não encontrado
 */
export function extractDocumentFromEntity(entity: any): string {
    if (!entity) return '';

    // Verificar se é pessoa física ou jurídica baseado no legal_personality
    // Aceita tanto string quanto number para compatibilidade
    const legalPersonality = entity.legalPersonality;
    const isPessoaFisica = legalPersonality === 1 ||
        legalPersonality === '1' ||
        legalPersonality === 'Pessoa Física';

    if (isPessoaFisica) {
        // Para pessoa física, priorizar CPF
        return entity.cpf || entity.document || '';
    } else {
        // Para pessoa jurídica, priorizar CNPJ
        return entity.cnpj || entity.document || '';
    }
}

/**
 * Extrai e formata o documento de uma entidade
 * @param entity Entidade com possíveis propriedades de documento
 * @returns String com o documento formatado, ou string vazia se não encontrado
 */
export function getFormattedDocumentFromEntity(entity: any): string {
    const doc = extractDocumentFromEntity(entity);
    return doc ? formatDocument(doc) : '';
} 